module.exports = __webpack_public_path__ + "img/programme5.602e4575.png";